import { render, staticRenderFns } from "./ExternalOrderItemList.vue?vue&type=template&id=22f187a0&"
import script from "./ExternalOrderItemList.vue?vue&type=script&lang=js&"
export * from "./ExternalOrderItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports